export default __webpack_public_path__ + "static/ProValue_4-0058393f26b8a168dd31e58eac7b3ae7.webp";